import { AdminSettingsPath } from '@/modules/admin/paths';
import { default as BaseSettings, Section } from '@/modules/settings/pages/Settings';
import { CurrencyDollarIcon, LanguageIcon, UserIcon } from '@heroicons/react/24/outline';
import { Outlet } from 'react-router-dom';

const sections: Section[] = [
  {
    href: AdminSettingsPath.profile,
    title: 'Profile',
    icon: UserIcon,
    children: [
      { href: AdminSettingsPath.profile, title: 'Profile', icon: UserIcon },
      { href: AdminSettingsPath.currency, title: 'Currency', icon: CurrencyDollarIcon },
      { href: AdminSettingsPath.language, title: 'Language', icon: LanguageIcon },
    ],
  },
];

export const Settings = () => {
  return (
    <BaseSettings sections={sections}>
      <Outlet />
    </BaseSettings>
  );
};

export default Settings;
